import { Review } from "./review";

export class ReviewDetail {
    oneStar: number;
    twoStars: number;
    threeStars: number;
    fourStars: number;
    fiveStars: number;
    reviews: Review[];
}
